// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"d4bee8d7","833":"d97b51fb"}[chunkId] + ".chunk.js";
};